import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Typography } from '@material-ui/core';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { CalculatingSpinner } from 'components/UI';
import { Tooltip } from 'components/UI/V3/Tooltip/Tooltip';
import { FunctionComponent } from 'react';

interface NormalItemProps {
    label: string;
    value: string | number;
    info?: string;
    topLine?: boolean;
    bottomLine?: boolean;
    loading?: boolean;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        row: (props: NormalItemProps) => ({
            width: '100%',
            display: 'flex',
            padding: '19px 0px',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: props.bottomLine ? '1px solid #D4D4D4' : undefined,

            [theme.breakpoints.down('sm')]: {
                borderTop: props.topLine ? '1px solid #D4D4D4' : undefined,

                ...(props.topLine && {
                    marginTop: 8
                })
            }
        }),
        text: {
            color: '#000',
            fontSize: 14,
            lineHeight: 1,
            fontWeight: 500
        },
        label: {
            display: 'flex',
            alignItems: 'center',
            gap: 6
        },
        infoIcon: {
            fontSize: 14,
            cursor: 'pointer',
            color: '#5E8677'
        }
    })
);

export const NormalItem: FunctionComponent<NormalItemProps> = props => {
    const classes = useStyles(props);

    return (
        <Box className={clsx(classes.row, props.className)}>
            <Box className={classes.label}>
                <Typography className={classes.text}>{props.label}</Typography>
                {props.info && (
                    <Tooltip
                        content={props.info}
                        placement="top"
                    >
                        <div>
                            <FontAwesomeIcon
                                icon={faInfoCircle}
                                className={classes.infoIcon}
                            />
                        </div>
                    </Tooltip>
                )}
            </Box>
            {props.loading ? <CalculatingSpinner /> : <Typography className={classes.text}>{props.value}</Typography>}
        </Box>
    );
};

export default NormalItem;
